import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import Grid, { GridProps } from "./Grid";

const PREFIX = "GridItemGrow";

const classes = {
	root: `${PREFIX}root`,
};

const StyledGrid = styled(Grid)(() => ({
	[`&.${classes.root}`]: {
		flexGrow: 1,
		overflow: "hidden",
	},
}));

export type GridItemGrowProps = Omit<GridProps, "container" | "item">;

const GridItemGrow: FunctionComponent<GridItemGrowProps> = (props) => {
	const { className, ...otherProps } = props;

	return (
		<StyledGrid
			className={`${classes.root} ${className || ""}`}
			item
			{...otherProps}
		/>
	);
};

export default GridItemGrow;